document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("csq-questionnaire-form");
  const step = CSQ.helpers.getQueryStringParameter("id");

  if (form === null || step !== "knowledge") {
    return;
  }

  const investmentsInFinancialInstruments = form.querySelector("#csq-investments-in-financial-instruments");
  const financialInstrumentsKnowledgeDetails = form.querySelector("#csq-financial-instruments-knowledge-details");

  investmentsInFinancialInstruments.addEventListener("change", (e) => {
    if (e.target.tagName !== "INPUT" || e.target.type !== "radio") {
      return;
    }

    if (e.target.value === "false" && e.target.checked) {
      financialInstrumentsKnowledgeDetails.style.display = "none";
      financialInstrumentsKnowledgeDetails.querySelectorAll("input, textarea").forEach(CSQ.helpers.clearInputField);
    } else {
      financialInstrumentsKnowledgeDetails.style.removeProperty("display");
    }
  });

  const crowdfundingSkills = form.querySelector("#csq-crowdfunding-skills");
  const crowdfundingInvestmentsDetails = form.querySelector("#csq-crowdfunding-investments-details");

  crowdfundingSkills.addEventListener("change", (e) => {
    if (e.target.tagName !== "INPUT" || e.target.type !== "radio") {
      return;
    }

    if (e.target.value === "false" && e.target.checked) {
      crowdfundingInvestmentsDetails.style.display = "none";
      crowdfundingInvestmentsDetails.querySelectorAll("input, textarea").forEach(CSQ.helpers.clearInputField);
    } else {
      crowdfundingInvestmentsDetails.style.removeProperty("display");
    }
  });
}, false);
